import React, { useState } from 'react';
import Base from '../base';
import ClaimPlatesForm from '../../components/forms/critical_plates/form.claim_plates';
import { Row, Col, Button, Form, Alert } from '@themesberg/react-bootstrap';
import { get } from '../../services/back.service';
import ListTables from '../../components/shared/tables';
import ModalMessage from '../../components/widgets/modalMessage';
// import ModalShowImagesCritical from '../../components/forms/critical_plates/modal.images';

function ClaimsPlates() {
  const [showModal, setShowModal] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [id_claim, setClaimSelected] = useState(false);
  const [showButtonForm, setShowButtonForm] = useState(false);
  const [plate, setPlate] = useState('');
  const [msgTable, setMsgTable] = useState('');
  const [listReports, setListReports] = useState([]);

  const viewDetail = (row) => {
    if (row.origen === 'Reclamos')
      return <Button onClick={() => showModalDelete(row)}>Borrar</Button>
  };

  const showModalDelete = (row) => {
    setClaimSelected(row.id)
    setShowModal(true)
  }

  const updateReport = async () => {
    if (plate !== '') {
      const respo = await get('/critical/report_claim/' + plate);
      if (respo.success) {
        setListReports(respo.data);
      } else {
        setMsgTable(respo.message);
      }
      setShowButtonForm(true);
      setShowForm(false)
    }
  }


  const validPlate = async (e) => {
    e.preventDefault();
    await updateReport();
  }

  const deleteClaim = async () => {
    console.log(id_claim);
    const respo = await get(`/critical/delete_claim/${plate}/${id_claim}`);
    if (!respo.success) console.log(respo)
    setShowModal(false)
    updateReport()
  }

  return (
    <Base>
      <Alert />
      <ModalMessage
        title={'Advertencia'}
        text={`Una vez elimine el cliente no se podra recuperar, esta seguro?`}
        showProps={showModal}
        funcAccept={deleteClaim}
        funcClose={() => setShowModal(false)}
      />
      <Row>
        <Col>
          <Form id='form_plate' onSubmit={(e) => validPlate(e)}>
            <Row className='mt-2'>
              <Col>
                <Form.Label htmlFor="nombre">PLACA</Form.Label>
                <Form.Control
                  name="plate"
                  value={plate}
                  onChange={({ target }) => { setPlate(target.value); setShowForm(false); setShowButtonForm(false); setListReports([]) }}
                  type="text"
                  className="fw-bold text-uppercase"
                  minLength={6}
                  maxLength={6}
                  required
                />
              </Col>
            </Row>
            <Row className='mt-2'>
              <Col>
                <Button type="submit">Buscar</Button>
              </Col>
              {showButtonForm &&
                <Col>
                  <Button onClick={() => setShowForm(true)}>Agregar Novedad</Button>
                </Col>}
            </Row>
          </Form>
          {showForm && <Row className='mt-2'><ClaimPlatesForm plate={plate} updateReport={updateReport} /></Row>}
        </Col>
        <Col>
          <ListTables
            data={listReports}
            editar={viewDetail}
            messageWd={msgTable}
            hideFirst={true}
          />
        </Col>
      </Row>
    </Base>
  );
}

export default ClaimsPlates;
